import axios from 'axios'
import { BUSCAR_CONFIGURACAO_ENCOMENDA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarConfiguracaoEncomenda(empresaId) {
  const url = `${URL}/empresas/${empresaId}/configuracao-encomenda`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: BUSCAR_CONFIGURACAO_ENCOMENDA,
      payload: response
    })
  );
}